import { useCallback, useContext, useEffect } from 'react';
import Portal from '@/common/Portal';
import { SectionViewedLogger } from '@/vdp/Analytics';
import Sections from '~/constants/vdp/sections';
import { useScreenSize } from '~/context/common/DeviceContext';
import CarouselContext from '~/context/vdp/CarouselContext';
import UiContext from '~/context/vdp/UiContext';
import { useGetHasImages } from '~/context/vdp/VehicleContext';
import { logError } from '~/utilities/loggers';
import FullScreenGallery from './Carousel/FullScreenGallery';
import TileCarousel from './Carousel/TileCarousel';

export default function Gallery() {
  const { isFullScreen } = useContext(CarouselContext);
  const { setSectionViewed } = useContext(UiContext);
  const hasImages = useGetHasImages();
  const isHeightLessThan610 = useScreenSize().height < 610;
  const viewedThreshold = isHeightLessThan610 ? 0.2 : 0.9;
  const viewedCallback = useCallback(() => {
    setSectionViewed(Sections.Gallery);
  }, [setSectionViewed]);

  useEffect(() => {
    if (hasImages) return;
    logError('No Gallery Images');
  }, [hasImages]);

  return hasImages ? (
    <SectionViewedLogger
      id={Sections.Gallery}
      callback={viewedCallback}
      threshold={viewedThreshold}
    >
      <Portal id="fullscreen-gallery" open={isFullScreen}>
        <FullScreenGallery />
      </Portal>
      <TileCarousel />
    </SectionViewedLogger>
  ) : null;
}
